import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    margin: '0 13px',
  },
  yellowText: {
    color: theme.palette.yellow.color,
  },
  firstColumn: {
    paddingLeft: 0
  },
  expandableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  expandIcon: {
    transition: 'transform 0.2s',
    fontSize: 16,
  },
  expandIconOpen: {
    transform: 'rotate(180deg)',
  },
  settingsCell: {
    paddingTop: 0,
    paddingBottom: 0,
    borderBottom: 'none',
  },
  settingsContent: {
    padding: theme.spacing(1, 2, 2),
  },
  settingsSection: {
    marginBottom: theme.spacing(1),
  },
  settingsSectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  settingsGrid: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
  },
  settingsLabel: {
    color: theme.palette.text.secondary,
  },
  riskRulesTable: {
    marginTop: theme.spacing(0.5),
    '& th, & td': {
      padding: theme.spacing(0.5, 1),
      fontSize: '0.8rem',
    },
  },
}))
